import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_17: FaireProductEntity = {
  token: "legacy_prod_abbott-17",
  type: "product",
  name: "White LED Taper Candle 9.5 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0efb1d45c0cecc3f95ea431ec00606086ab96c45348201326dd6186bf23f12ee.jpeg",
  priceDollars: 14,
  msrpDollars: 28,
  subcategory: "Taper Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
